/* global attachEvent, windowWidth, breakpointMd */

// *******************************************************************************
// 1.0 - Submenus toggle
// *******************************************************************************

attachEvent('.has-sub .menu__link--level-1', 'click', (ev) => {
  if (windowWidth() < breakpointMd) {
    ev.preventDefault();
    ev.target.closest('.menu__item').classList.toggle('is-open-submenu');
  }
});
